<div class="confirmation-modal-wrapper">
  <app-base-modal dialogTitle="Add incident" (closeEvent)="onCancel()">
    <div class="modal-hint">Select how you want to add the incident.</div>

    <mat-radio-group class="options-group" [(ngModel)]="selectedOption">
      @for (option of options; track option) {
        <mat-radio-button class="option" [value]="option">
          <div class="option-text">
            <div class="title">
              {{ optionsMeta[option].title }}
            </div>
            <div class="sub-title">
              {{ optionsMeta[option].description }}
            </div>
          </div>
        </mat-radio-button>
      }
    </mat-radio-group>

    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
      <button mat-flat-button class="button-primary" (click)="onContinue()">Continue</button>
    </div>
  </app-base-modal>
</div>
